import { render, staticRenderFns } from "./StudyExplanation.vue?vue&type=template&id=258b2dea&scoped=true&lang=pug&"
import script from "./StudyExplanation.vue?vue&type=script&lang=ts&"
export * from "./StudyExplanation.vue?vue&type=script&lang=ts&"
import style0 from "./StudyExplanation.vue?vue&type=style&index=0&id=258b2dea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b2dea",
  null
  
)

export default component.exports